<template>
  <div>
    <!-- <pre>{{carsRegularReservation}}</pre> -->
    <back-to-top left visibleoffset="150">
      <v-btn small fab color="green" dark> <v-icon>mdi-arrow-up-bold</v-icon></v-btn>
    </back-to-top>

    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-card>
      <v-container>
        <!--start for mobile view -->
        <v-row v-if="$vuetify.breakpoint.smAndDown">
          <h4
            class="ml-3"
            v-if="$i18n.locale == 'ja'"
            style="color: red; font-family: Verdana; font-size: 12px; font-weight: bold"
          >
            {{ timeCutoff[0] }}時{{ timeCutoff[1] }}{{ $t("cars.TimeCutOff") }}
          </h4>
          <h4
            v-else
            class="ml-3"
            style="color: red; font-family: Verdana; font-size: 12px; font-weight: bold"
          >
            {{ $t("cars.TimeCutOff") }} {{ timeCutoff[0] }}:{{ timeCutoff[1] }}.
          </h4>
          <br /><span style="font-family: Arial">{{ notedRemarks }}</span>
          <br />
          <v-card style="margin-left: 10px" color="transparent" flat>
            <h5 class="mr-3 ml-3" style="font-family: Verdana; font-size: 13px">
              {{ dateToday }}
            </h5>

            <h5 class="mr-3 ml-3" style="font-family: Verdana; font-size: 13px">
              {{ timeToday }}
            </h5>
          </v-card>

          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn
                @click="OpenDefaultDialog()"
                v-on="on"
                fab
                x-small
                color="primary"
                style="margin-right: 10px"
              >
                <v-icon>mdi-cog</v-icon>
              </v-btn>
            </template>
            <span style="font-family: Arial"> {{ $t("cars.myAccount") }} </span>
          </v-tooltip>
        </v-row>
        <!-- end for mobile view -->
        <v-row v-else>
          <h4
            class="ml-3"
            v-if="$i18n.locale == 'ja'"
            style="
              color: red;
              font-family: Verdana;
              font-size: fontSize;
              font-weight: bold;
            "
          >
            {{ timeCutoff[0] }}時{{ timeCutoff[1] }}{{ $t("cars.TimeCutOff") }}
          </h4>
          <h4
            v-else
            style="
              color: red;
              font-family: Verdana;
              font-size: fontSize;
              font-weight: bold;
            "
          >
            {{ $t("cars.TimeCutOff") }} {{ timeCutoff[0] }}:{{ timeCutoff[1] }}.
          </h4>

          <v-spacer></v-spacer>
          <v-card style="margin-top: -10px" class="mr-3" flat color="transparent">
            <v-container>
              <h5 class="text-center" style="font-family: Verdana; font-size: fontSize">
                {{ dateToday }}
              </h5>

              <h5 class="text-center" style="font-family: Verdana; font-size: fontSize">
                {{ timeToday }}
              </h5>
            </v-container>
          </v-card>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                @click="OpenDefaultDialog()"
                v-on="on"
                fab
                small
                color="primary"
                style="margin-right: 10px"
              >
                <v-icon>mdi-cog</v-icon>
              </v-btn>
            </template>
            <span style="font-family: Arial"> {{ $t("cars.myAccount") }} </span>
          </v-tooltip>
        </v-row>
        <span
          style="color: red; font-family: Verdana; font-size: 18px; font-weight: bold"
          v-if="notedRemarks != ''"
          >Note : {{ notedRemarks }}</span
        >
        <!-- {{FinishData}}<br>
    <pre>{{listIDneededtoEliminate}}</pre> -->

        <v-tabs
          show-arrows
          next-icon="mdi-arrow-right-bold-box-outline"
          prev-icon="mdi-arrow-left-bold-box-outline"
          slider-size="5"
          centered
          grow
          v-model="tabs"
          background-color="white"
          center-active
          color="#247ef2"
        >
          <v-tab
            ><v-icon left color="#ef9a9a">mdi-car</v-icon
            ><span style="font-family: Verdana; font-weight: bold">{{
              $t("cars.lblRegular")
            }}</span>
          </v-tab>
          <v-tab
            ><v-icon left color="yellow lighten-3">mdi-car</v-icon>
            <span style="font-family: Verdana; font-weight: bold"
              >{{ $t("cars.lblSpecial") }}
            </span>
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tabs">
          <h2
            v-if="ReservationLock == 'TRUE'"
            style="color: red; font-family: Verdana; font-size: 25px"
            class="text-center"
          >
            {{ $t("cars.msgAssign") }}
          </h2>
          <v-tab-item>
            <v-layout row wrap>
              <!-- <v-container> -->
              <v-col cols="12">
                <!-- w/ plateNo  <pre> {{carsRegularReservation}} </pre>
              w/o plateNo <pre> {{ReserveData}}</pre> -->
                <!-- <pre>  {{ carsSpecialReservation[0].recs[0].recs1 }}  </pre> -->
                <v-card flat width="100%" dense>
                  <v-col
                    class="pb-0 pt-0"
                    cols="12"
                    v-for="(rec, i) in carsRegularReservation"
                    :key="i + 'a'"
                  >
                    <template v-for="(r, a) in rec.recs">
                      <v-card
                        :key="a + 't'"
                        v-if="r.PlateNo !== 'null'"
                        class="pb-1 pt-0"
                        raised
                      >
                        <template v-if="$vuetify.breakpoint.smAndDown">
                          <v-system-bar height="30" color="red lighten-3">
                            <span
                              class="pl-1 mb-1"
                              style="
                                font-family: Verdana;
                                font-size: 15px;
                                font-weight: bold;
                                color: black;
                              "
                              >{{ rec.timeDisplay }}</span
                            >
                            <v-spacer></v-spacer>

                            <template v-if="ReservationLock == 'FALSE'">
                              <v-btn
                                class="mt-1"
                                v-if="
                                  listIdreserved.length == 0 &&
                                  r.recs1.length < r.recs1[0].capacity - 1
                                "
                                @click="EnableJoin(r.recs1[0])"
                                x-small
                                raised
                                ><span style="font-family: Verdana"
                                  >{{ $t("cars.join") }}
                                </span>
                              </v-btn>
                              <!-- <v-btn class="mt-1" v-else-if="listIdreserved.length === 1 && r.recs1.length < (r.recs1[0].capacity - 1)"  color="transparent" flat text></v-btn>  -->
                            </template>
                          </v-system-bar>

                          <v-card
                            color="red lighten-3"
                            tile
                            v-if="$vuetify.breakpoint.xsOnly"
                          >
                            <template v-if="r.recs1[0].designation !== 0">
                              <span
                                class="mt-0 mb-0 mr-8 ml-3"
                                v-if="r.recs1[0].designation === 1"
                                style="
                                  color: black;
                                  font-family: Verdana;
                                  font-size: 14px;
                                  font-weight: bold;
                                "
                                >Seaview -> NAIA</span
                              >
                              <span
                                class="mt-0 mb-0 mr-10 ml-3"
                                v-if="r.recs1[0].designation === 2"
                                style="
                                  margin-top: 5px;
                                  color: black;
                                  font-family: Verdana;
                                  font-size: 14px;
                                  font-weight: bold;
                                "
                                >Makati Only</span
                              > </template
                            ><br />
                            <span
                              class="ml-3 mr-10"
                              style="
                                color: black;
                                font-family: Verdana;
                                font-size: 14px;
                                font-weight: bold;
                              "
                              >{{ r.PlateNo }} ({{ r.recs1[0].typeofCar }})</span
                            >

                            <div
                              class="ml-3"
                              style="
                                color: black;
                                font-family: Verdana;
                                font-size: 14px;
                                font-weight: bold;
                              "
                            >
                              Driver : {{ r.recs1[0].Driver }}
                            </div>
                            <div
                              class="ml-3"
                              style="
                                color: black;
                                font-family: Verdana;
                                font-size: 14px;
                                font-weight: bold;
                              "
                            >
                              Contact : {{ r.recs1[0].driverContacts }}
                            </div>
                          </v-card>

                          <v-card
                            color="red lighten-3"
                            tile
                            v-if="$vuetify.breakpoint.smOnly"
                          >
                            <span
                              class="ml-3 mr-8 text-right"
                              style="
                                color: black;
                                font-family: Verdana;
                                font-size: 14px;
                                font-weight: bold;
                              "
                              >{{ r.PlateNo }} ({{ r.recs1[0].typeofCar }})</span
                            >
                            <template v-if="r.recs1[0].designation !== 0">
                              <span
                                class="mt-0 mb-0 ml-3"
                                v-if="r.recs1[0].designation === 1"
                                style="
                                  color: black;
                                  font-family: Verdana;
                                  font-size: 14px;
                                  font-weight: bold;
                                "
                                >Seaview -> NAIA</span
                              >
                              <span
                                class="mt-0 mb-0 ml-3"
                                v-if="r.recs1[0].designation === 2"
                                style="
                                  margin-top: 5px;
                                  color: black;
                                  font-family: Verdana;
                                  font-size: 14px;
                                  font-weight: bold;
                                "
                                >Makati Only</span
                              >
                            </template>
                            <br />
                            <span
                              class="ml-3 mr-3"
                              style="
                                color: black;
                                font-family: Verdana;
                                font-size: 14px;
                                font-weight: bold;
                              "
                              >Driver : {{ r.recs1[0].Driver }}</span
                            >
                            <span
                              class="ml-3"
                              style="
                                color: black;
                                font-family: Verdana;
                                font-size: 14px;
                                font-weight: bold;
                              "
                              >Contact : {{ r.recs1[0].driverContacts }}
                            </span>
                          </v-card>
                        </template>
                        <template v-else>
                          <v-toolbar
                            window
                            lights-out
                            dense
                            color="red lighten-3"
                            style="padding-top: 0px; padding-bottom: 0px"
                          >
                            <div>
                              <span
                                class="mt-0 mb-0 mr-10"
                                v-if="CheckDayCode(r.recs1[0].Day_Code)"
                                style="
                                  color: red;
                                  font-family: Verdana;
                                  font-weight: bold;
                                  font-size: 12px;
                                "
                                >[Coding Car] <br
                              /></span>
                              <span
                                class="mt-0 mb-0 mr-10"
                                style="
                                  font-family: Verdana;
                                  font-size: 15px;
                                  font-weight: bold;
                                  color: black;
                                  padding-top: 0px;
                                  padding-bottom: 0px;
                                "
                                >{{ rec.timeDisplay }}
                              </span>
                            </div>

                            <template v-if="r.recs1[0].designation !== 0">
                              <span
                                class="mt-0 mb-0 mr-8"
                                v-if="r.recs1[0].designation === 1"
                                style="
                                  color: black;
                                  font-family: Verdana;
                                  font-size: 14px;
                                  font-weight: bold;
                                "
                                >Seaview -> NAIA</span
                              >
                              <span
                                class="mt-0 mb-0 mr-10"
                                v-if="r.recs1[0].designation === 2"
                                style="
                                  margin-top: 5px;
                                  color: black;
                                  font-family: Verdana;
                                  font-size: 14px;
                                  font-weight: bold;
                                "
                                >Makati Only</span
                              >
                            </template>

                            <span
                              class="ml-2 mr-10"
                              style="
                                color: black;
                                font-family: Verdana;
                                font-size: 14px;
                                font-weight: bold;
                              "
                              >{{ r.PlateNo }} <br />
                              ({{ r.recs1[0].typeofCar }})</span
                            >
                            <v-row>
                              <v-col cols="12">
                                <div
                                  style="
                                    color: black;
                                    font-family: Verdana;
                                    font-size: 14px;
                                    font-weight: bold;
                                  "
                                >
                                  Driver : {{ r.recs1[0].Driver }}
                                </div>
                                <div
                                  style="
                                    color: black;
                                    font-family: Verdana;
                                    font-size: 14px;
                                    font-weight: bold;
                                  "
                                >
                                  Contact : {{ r.recs1[0].driverContacts }}
                                </div>
                              </v-col>
                            </v-row>

                            <template v-if="ReservationLock == 'FALSE'">
                              <v-btn
                                class="mt-1"
                                v-if="
                                  listIdreserved.length === 0 &&
                                  r.recs1.length < r.recs1[0].capacity - 1
                                "
                                @click="EnableJoin(r.recs1[0])"
                                small
                                raised
                                ><span style="font-family: Verdana">{{
                                  $t("cars.join")
                                }}</span>
                              </v-btn>
                            </template>
                          </v-toolbar>
                        </template>
                        <v-card-text>
                          <v-layout row class="ma-0 pa-0">
                            <v-col class="pt-0 pb-0">
                              <p
                                class="subtitle-1 black--text"
                                style="font-family: Verdana; font-weight: bold"
                              >
                                <template v-for="(per, k) in r.recs1">
                                  <v-tooltip
                                    bottom
                                    :key="k + 'c'"
                                    color="grey darken-3"
                                    transition="slide-y-transition"
                                  >

                                    <template v-slot:activator="{ on }">
                                      <v-chip
                                        v-if="ReservationLock == 'FALSE'"
                                        :key="k + 'c'"
                                        small
                                        style="
                                          color: black;
                                          font-family: Verdana;
                                          font-size: 14px;
                                        "
                                        :close="
                                          per.empId === userData.id ||
                                          per.R_id === userData.id
                                            ? true
                                            : false
                                        "
                                        @click:close="
                                          cancelReservation(per.empId, per.EmpName)
                                        "
                                        v-on="on"
                                         @mouseenter="onTooltipOpen(per)"
                                      >
                                        {{ per.EmpName }}
                                      </v-chip>
                                      <v-chip
                                        v-else
                                        :key="k + 'c'"
                                        small
                                        style="
                                          color: black;
                                          font-family: Verdana;
                                          font-size: 14px;
                                        "
                                        v-on="on"
                                        @mouseenter="onTooltipOpen(per)"
                                      >
                                        {{ per.EmpName }}
                                      </v-chip>
                                    </template>

                                    <span
                                      style="
                                        font-family: Verdana;
                                        color: white;
                                        font-weight: bold;
                                        text-align: justify;
                                      "
                                      >NAME : {{ per.EmpName }}<br />
                                      PICKUP : {{ per.pickupName }}<br />
                                      ADDRESS : {{ per.DropPoint }}<br />
                                      RESIDENCE : {{ per.DropPointDetails }}<br />
                                      CELLPHONE : {{ per.localNumber }} <br/>
                                      LOCAL: {{ per.internalLocalNumber ? per.internalLocalNumber  : '-'}}
                                    </span>
                                  </v-tooltip>
                                </template>
                              </p>
                            </v-col>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                    </template>
                  </v-col>
                  <!-- with out plateNo         timeToday >= reloadtime && timeToday < cutOff ||               -->
                  <!-- <template  v-if="timeToday >= reloadtime || timeToday <= cutOff" > -->
                  <template v-if="ReservationLock == 'FALSE'">
                    <template v-for="(rec2, a) in ReserveData1">
                      <v-layout :key="a + 'z'">
                        <v-col class="pb-1 pt-0" cols="12">
                          <v-card raised>
                            <v-system-bar height="30" color="red lighten-3">
                              <span
                                class="pl-4 mb-1"
                                style="
                                  font-family: Verdana;
                                  font-size: 15px;
                                  font-weight: bold;
                                  color: black;
                                "
                                >{{ rec2.timeDisplay }}
                              </span>

                              <v-spacer></v-spacer>

                              <template v-if="listIdreserved.length === 0">
                                <v-btn
                                  v-if="ReservationLock == 'FALSE'"
                                  @click="selectName(rec2)"
                                  :x-small="$vuetify.breakpoint.xsOnly"
                                  :small="$vuetify.breakpoint.smAndUp"
                                  raised
                                  style="font-family: Verdana"
                                  >{{ $t("cars.join") }}
                                </v-btn>
                              </template>

                              <template v-else>
                                <v-layout
                                  v-for="(list, index) in listIdreserved"
                                  :key="index"
                                >
                                  <v-spacer></v-spacer>
                                  <v-btn
                                    v-if="
                                      rec2.timeID === list.timeID && list.plateNo === null
                                    "
                                    @click="canceReservation(list, list.empId)"
                                    x-small
                                    raised
                                    autofocus
                                    style="font-family: Verdana"
                                    >cancel</v-btn
                                  >
                                </v-layout>
                              </template>
                            </v-system-bar>
                            <v-list-item>
                              <v-layout row wrap>
                                <v-col class="pt-0 pb-0">
                                  <p
                                    class="subtitle-1 black--text"
                                    style="
                                      font-family: Verdana;
                                      font-weight: bold;
                                      font-size: 8px;
                                    "
                                  >
                                    <template
                                      v-for="(item, index1) in carsReservationData1"
                                    >
                                      <v-tooltip
                                        bottom
                                        :key="index1"
                                        color="grey darken-3"
                                        transition="slide-y-transition"
                                        
                                      >
                                        <template v-slot:activator="{ on }">
                                          <v-chip
                                            :key="index1"
                                            small
                                            v-show="
                                              item.timeID === rec2.timeID &&
                                              item.plateNo == null
                                            "
                                            style="font-family: Verdana; font-size: 14px"
                                            v-on="on"
                                            @mouseenter="onTooltipOpen(item)"
                                          >
                                            {{ item.EmpName }}
                                          </v-chip>
                                        </template>

                                        <span
                                          style="
                                            color: white;
                                            font-weight: bold;
                                            text-align: justify;
                                            font-family: Verdana;
                                          "
                                          >NAME : {{ item.EmpName }}<br />
                                          PICKUP : {{ item.pickupName }}<br />
                                          ADDRESS : {{ item.DropPoint }}<br />
                                          RESIDENCE : {{ item.DropPointDetails }}<br />
                                          CELLPHONE : {{ item.phoneNumber }} <br/>
                                          LOCAL: {{ item.internalLocalNumber ? item.internalLocalNumber  : '-'}}
                                          <!-- <pre> {{ item }}</pre> -->
                                        </span>
                                      </v-tooltip>
                                    </template>
                                  </p>
                                </v-col>
                              </v-layout>
                            </v-list-item>
                          </v-card>
                        </v-col>
                      </v-layout>
                    </template>
                  </template>
                </v-card>
              </v-col>
              <!-- </v-container> -->
            </v-layout>
            <v-dialog v-model="DialogR" persistent width="250">
              <v-card height="350">
                <v-toolbar dense color="red lighten-3">
                  <v-toolbar-title>{{ $t("cars.details") }}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn small icon @click="closeDialog()" class="mr-0"
                    ><v-icon>mdi-close</v-icon></v-btn
                  >
                </v-toolbar>
                <v-list-item three-line>
                  <v-list-item-content>
                    <v-list-item-title
                      v-model="toAdd.timeDisplay"
                      class="mb-2 mt-0 text-center"
                      style="font-family: Verdana; font-size: 20px"
                      >{{ toAdd.timeDisplay }}</v-list-item-title
                    >
                    <v-list-item-subtitle>
                      <v-select
                        v-model="toAdd.pickupName"
                        :items="PickUpPointList"
                        dense
                        outlined
                        :label="$t('cars.pickupPoint')"
                        class="mt-2"
                        required
                        style="font-family: Verdana"
                      ></v-select>
                      <v-text-field
                        readonly
                        v-model="toAdd.DropPoint"
                        outlined
                        dense
                        :label="$t('cars.dropPoint')"
                        required
                        style="font-family: Verdana"
                      ></v-text-field>
                      <v-text-field
                        readonly
                        v-model="toAdd.DropPointDetails"
                        outlined
                        dense
                        :label="$t('cars.dropPoint')"
                        required
                        style="font-family: Verdana"
                      ></v-text-field>
                      <v-btn
                        @click="joinReservation()"
                        :disabled="!valid"
                        color="success"
                        block
                        dense
                        style="font-family: Verdana; font-size: 18px"
                        >Ok</v-btn
                      >
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-dialog>
          </v-tab-item>
          <v-tab-item>
            <v-layout row wrap>
              <v-col cols="12">
                <v-toolbar
                  v-if="ReservationLock == 'FALSE' && listIdreserved.length == 0"
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    class="margin-bottom : 5px"
                    v-if="listIdreserved.length == 0"
                    @click="openDialogS()"
                    rounded
                    style="font-family: Verdana"
                    ><v-icon>mdi-plus-thick</v-icon
                    ><span style="font-family: Verdana; font-size: 12px">{{
                      $t("cars.lblSpecial")
                    }}</span></v-btn
                  >
                </v-toolbar>

                <v-card flat width="100%">
                  <v-col
                    class="pb-0 pt-0"
                    cols="12"
                    v-for="(rec, i) in carsSpecialReservation1"
                    :key="i + 'a'"
                  >
                    <!-- Special Cars -->
                    <!-- {{carsSpecialReservation}} -->
                    <template v-for="(r, a) in rec.recs">
                      <v-card
                        :key="a + 't'"
                        style="padding-top: 0px; padding-bottom: 0px"
                      >
                        <template v-if="$vuetify.breakpoint.smAndDown">
                          <v-system-bar height="40" color="yellow lighten-3">
                            <span
                              class="mt-0 mb-0 mr-10 ml-0"
                              style="
                                color: black;
                                font-family: Verdana;
                                font-size: 15px;
                                font-weight: bold;
                                padding-top: 0px;
                                padding-bottom: 0px;
                              "
                              >{{ rec.timeDisplay }}
                            </span>
                            <v-spacer></v-spacer>

                            <v-card
                              v-if="ReservationLock == 'FALSE'"
                              color="transparent"
                              flat
                            >
                              <template
                                v-if="listIdreserved.length === 0 && r.PlateNo === 'null'"
                              >
                                <v-btn @click="selectNameS(r.recs1)" small raised
                                  ><span style="font-family: Verdana">{{
                                    $t("cars.join")
                                  }}</span></v-btn
                                >
                              </template>

                              <template v-else>
                                <v-layout
                                  v-for="(list, index) in listIdreserved"
                                  :key="index"
                                >
                                  <v-tooltip bottom v-if="ReservationLock == 'FALSE'">
                                    <template v-slot:activator="{ on }">
                                      <v-btn
                                        v-on="on"
                                        fab
                                        x-small
                                        v-if="
                                          rec.R_id === list.empId && r.PlateNo === 'null'
                                        "
                                        @click="editSpcialReserv(r.recs1)"
                                      >
                                        <v-icon color="black">mdi-pencil</v-icon>
                                      </v-btn>
                                    </template>

                                    <span> Edit </span>
                                  </v-tooltip>
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                      <v-btn
                                        v-show="ReservationLock === 'FALSE'"
                                        class="pr-0"
                                        v-on="on"
                                        fab
                                        x-small
                                        v-if="rec.R_id === list.empId"
                                        @click="cancelAllspecialReserve()"
                                      >
                                        <v-icon color="black"
                                          >mdi-trash-can-outline</v-icon
                                        >
                                      </v-btn>
                                    </template>
                                    <span>Cancel Reservation</span>
                                  </v-tooltip>
                                </v-layout>
                              </template>
                            </v-card>
                          </v-system-bar>
                          <v-card
                            color="yellow lighten-3"
                            v-if="$vuetify.breakpoint.xsOnly"
                          >
                            <template v-if="r.PlateNo !== 'null'">
                              <span v-if="CheckDayCode(r.Day_Code)">[Coding Car]</span>
                              <span
                                class="mr-8 ml-5 text-sm-left"
                                style="
                                  color: black;
                                  font-family: Verdana;
                                  font-size: 16px;
                                  font-weight: bold;
                                "
                                >{{ r.PlateNo }} ({{ r.recs1[0].typeofCar }})</span
                              ><br />
                              <span
                                class="mr-8 ml-5 text-sm-left"
                                style="
                                  color: black;
                                  font-family: Verdana;
                                  font-weight: bold;
                                  font-size: 12px;
                                "
                              >
                                Driver : {{ r.recs1[0].Driver }} <br />
                                <span
                                  class="mr-8 ml-5 text-sm-left"
                                  style="
                                    color: black;
                                    font-family: Verdana;
                                    font-size: 13px;
                                  "
                                  >Contact : {{ r.recs1[0].driverContacts }}</span
                                ></span
                              > </template
                            ><br />
                            <span
                              class="ml-5 text-sm-left"
                              style="
                                color: black;
                                font-family: Verdana;
                                font-size: 12px;
                                font-weight: bold;
                              "
                              >Reserved by : {{ r.recs1[0].R_Name }} <br />
                              <span
                                class="ml-5 text-sm-left"
                                v-if="!r.recs1[0].EventVenue"
                                style="
                                  color: black;
                                  font-family: Verdana;
                                  font-size: 12px;
                                "
                              >
                                <span v-if="r.recs1[0].Remarks == 'Others'">
                                  Purpose : {{ r.recs1[0].Remarks }} -
                                  {{ r.recs1[0].OtherRemarks }} /
                                  {{ r.recs1[0].DropPoint }}
                                </span>
                                <span v-else
                                  >Purpose : {{ r.recs1[0].Remarks }} /
                                  {{ r.recs1[0].DropPoint }}</span
                                >
                              </span>
                              <span
                                class="ml-5 text-sm-left"
                                v-else
                                style="
                                  color: black;
                                  font-family: Verdana;
                                  font-size: 13px;
                                "
                                >Purpose : {{ r.recs1[0].Remarks }} /
                                {{ r.recs1[0].EventVenue }} /{{ r.recs1[0].DropPoint }}
                              </span></span
                            >
                          </v-card>
                          <v-card
                            color="yellow lighten-3"
                            v-if="$vuetify.breakpoint.smOnly"
                          >
                            <template v-if="r.PlateNo !== 'null'">
                              <span
                                class="mr-8 ml-5 text-sm-left"
                                style="
                                  color: black;
                                  font-family: Verdana;
                                  font-size: 16px;
                                  font-weight: bold;
                                "
                                >{{ r.PlateNo }} ({{ r.recs1[0].typeofCar }})</span
                              ><br />
                              <span
                                class="mr-8 ml-5 text-sm-left"
                                style="
                                  color: black;
                                  font-family: Verdana;
                                  font-weight: bold;
                                  font-size: 12px;
                                "
                              >
                                Driver : {{ r.recs1[0].Driver }}
                                <span
                                  class="mr-8 ml-5 text-sm-left"
                                  style="
                                    color: black;
                                    font-family: Verdana;
                                    font-size: 13px;
                                  "
                                  >Contact : {{ r.recs1[0].driverContacts }}</span
                                ></span
                              > </template
                            ><br />
                            <span
                              class="ml-5 text-sm-left"
                              style="
                                color: black;
                                font-family: Verdana;
                                font-size: 12px;
                                font-weight: bold;
                              "
                              >Reserved by : {{ r.recs1[0].R_Name }}
                              <span
                                class="ml-5 text-sm-left"
                                v-if="!r.recs1[0].EventVenue"
                                style="
                                  color: black;
                                  font-family: Verdana;
                                  font-size: 12px;
                                "
                              >
                                <span v-if="r.recs1[0].Remarks == 'Others'">
                                  Purpose : {{ r.recs1[0].Remarks }} -
                                  {{ r.recs1[0].OtherRemarks }} /
                                  {{ r.recs1[0].DropPoint }}
                                </span>
                                <span v-else
                                  >Purpose : {{ r.recs1[0].Remarks }} /
                                  {{ r.recs1[0].DropPoint }}</span
                                >
                              </span>

                              <span
                                class="ml-5 text-sm-left"
                                v-else
                                style="
                                  color: black;
                                  font-family: Verdana;
                                  font-size: 13px;
                                "
                                >Purpose : {{ r.recs1[0].Remarks }} /
                                {{ r.recs1[0].EventVenue }} /{{ r.recs1[0].DropPoint }}
                              </span></span
                            >
                          </v-card>
                        </template>

                        <template v-else>
                          <v-toolbar
                            window
                            lights-out
                            dense
                            color="yellow lighten-3"
                            style="padding-top: 0px; padding-bottom: 0px"
                          >
                            <div>
                              <span
                                class="mt-0 mb-0 mr-10"
                                v-if="CheckDayCode(r.recs1[0].Day_Code)"
                                style="
                                  color: red;
                                  font-family: Verdana;
                                  font-weight: bold;
                                  font-size: 12px;
                                "
                                >[Coding Car] <br
                              /></span>
                              <span
                                class="mt-0 mb-0 mr-10"
                                style="
                                  color: black;
                                  font-family: Verdana;
                                  font-size: 15px;
                                  font-weight: bold;
                                  padding-top: 0px;
                                  padding-bottom: 0px;
                                "
                                >{{ rec.timeDisplay }}
                              </span>
                            </div>

                            <v-row>
                              <template v-if="r.PlateNo !== 'null'">
                                <span
                                  class="mr-8"
                                  style="
                                    color: black;
                                    font-family: Verdana;
                                    font-size: adjustFontSize;
                                    font-weight: bold;
                                  "
                                  >{{ r.PlateNo }} <br />
                                  ({{ r.recs1[0].typeofCar }})
                                </span>
                                <span
                                  class="mr-8"
                                  style="
                                    color: black;
                                    font-family: Verdana;
                                    font-weight: bold;
                                    font-size: 13px;
                                  "
                                >
                                  Driver : {{ r.recs1[0].Driver }} <br />
                                  <span
                                    style="
                                      color: black;
                                      font-family: Verdana;
                                      font-size: 14px;
                                    "
                                    >Contact : {{ r.recs1[0].driverContacts }}</span
                                  ></span
                                >
                              </template>
                              <span
                                style="
                                  color: black;
                                  font-family: Verdana;
                                  font-size: 14px;
                                  font-weight: bold;
                                "
                                >Reserved by : {{ r.recs1[0].R_Name }} <br />
                                <span
                                  v-if="!r.recs1[0].EventVenue"
                                  style="
                                    color: black;
                                    font-family: Verdana;
                                    font-size: 13px;
                                  "
                                >
                                  <span v-if="r.recs1[0].Remarks === 'Others'">
                                    Purpose : {{ r.recs1[0].Remarks }} -
                                    {{ r.recs1[0].OtherRemarks }} /
                                    {{ r.recs1[0].DropPoint }}
                                  </span>
                                  <span v-else
                                    >Purpose : {{ r.recs1[0].Remarks }} /
                                    {{ r.recs1[0].DropPoint }}</span
                                  >
                                </span>
                                <span
                                  v-else
                                  style="
                                    color: black;
                                    font-family: Verdana;
                                    font-size: 13px;
                                  "
                                  >Purpose : {{ r.recs1[0].Remarks }} /
                                  {{ r.recs1[0].EventVenue }} /{{ r.recs1[0].DropPoint }}
                                </span></span
                              >
                            </v-row>
                            <v-spacer></v-spacer>

                            <v-card
                              v-if="ReservationLock == 'FALSE'"
                              color="transparent"
                              flat
                            >
                              <template
                                v-if="listIdreserved.length === 0 && r.PlateNo === 'null'"
                              >
                                <v-btn @click="selectNameS(r.recs1)" small raised
                                  ><span style="font-family: Verdana">{{
                                    $t("cars.join")
                                  }}</span></v-btn
                                >
                              </template>

                              <template v-else>
                                <v-layout
                                  v-for="(list, index) in listIdreserved"
                                  :key="index"
                                >
                                  <v-tooltip bottom v-if="ReservationLock == 'FALSE'">
                                    <template v-slot:activator="{ on }">
                                      <v-btn
                                        v-on="on"
                                        fab
                                        x-small
                                        v-if="
                                          rec.R_id === list.empId && r.PlateNo === 'null'
                                        "
                                        @click="editSpcialReserv(r.recs1)"
                                      >
                                        <v-icon color="black">mdi-pencil</v-icon>
                                      </v-btn>
                                    </template>

                                    <span> Edit </span>
                                  </v-tooltip>
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                      <v-btn
                                        v-show="ReservationLock === 'FALSE'"
                                        class="pr-0"
                                        v-on="on"
                                        fab
                                        x-small
                                        v-if="rec.R_id === list.empId"
                                        @click="cancelAllspecialReserve()"
                                      >
                                        <v-icon color="black"
                                          >mdi-trash-can-outline</v-icon
                                        >
                                      </v-btn>
                                    </template>
                                    <span>Cancel Reservation</span>
                                  </v-tooltip>
                                </v-layout>
                              </template>
                            </v-card>
                          </v-toolbar>
                        </template>
                        <v-card-text>
                          <template v-for="(per, k) in r.recs1">
                            <v-tooltip
                              bottom
                              :key="k"
                              color="grey darken-3"
                              transition="slide-y-transition"
                            >
                              <template v-slot:activator="{ on }">
                                <v-chip
                                  :key="k + 'c'"
                                  small
                                  class="body-1 black--text ma-1"
                                  style="color: black; font-family: Verdana"
                                  :close="
                                    (per.empId === userData.id ||
                                      per.R_id === userData.id) &&
                                    ReservationLock === 'FALSE'
                                      ? true
                                      : false
                                  "
                                  @click:close="cancelReservation(per.empId, per.EmpName)"
                                  v-on="on"
                                  @mouseenter="onTooltipOpen(per)"
                                >
                                  {{ per.EmpName }}
                                </v-chip>
                              </template>

                              <span
                                style="
                                  color: white;
                                  font-weight: bold;
                                  text-align: justify;
                                  font-family: Verdana;
                                "
                                >NAME : {{ per.EmpName }}<br />
                                PICKUP : {{ per.pickupName }}<br />
                                ADDRESS : {{ per.DropPoint }}<br />
                                RESIDENCE : {{ per.DropPointDetails }}<br />
                                CELLPHONE : {{ per.localNumber }} <br/>
                                LOCAL: {{ per.internalLocalNumber ? per.internalLocalNumber  : '-'}}
                              </span>
                            </v-tooltip>
                          </template>
                        </v-card-text>
                      </v-card>
                    </template>
                  </v-col>
                </v-card>
              </v-col>
            </v-layout>
          </v-tab-item>
        </v-tabs-items>
        <v-dialog
          v-model="DialogS"
          persistent
          width="620"
          :fullscreen="$vuetify.breakpoint.xsOnly"
        >
          <v-toolbar dense color="yellow lighten-3">
            <v-toolbar-title style="font-family: Verdana; font-size: 17px">
              {{ specialTitle }}</v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-btn small icon @click="closeDialogS()" class="mr-0"
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </v-toolbar>

          <v-card :max-height="600" flat style="border: 1px solid grey">
            <v-container fluid>
              <v-form ref="form" v-model="valid2">
                <!-- {{Members}} -->
                <!-- {{toAddS}}  -->
                <v-row wrap>
                  <v-col cols="12" xs="12" sm="6" md="6" lg="6">
                    <v-text-field
                      :label="$t('cars.reservedby')"
                      dense
                      v-model="toAddS.R_Name"
                      readonly
                      style="font-family: Verdana"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" xs="12" sm="6" md="6" lg="6">
                    <v-combobox
                      @change="selectPickUpName(toAddS.pickupName)"
                      :label="$t('cars.pickupPoint')"
                      style="font-family: Verdana"
                      :items="PickUpPointList"
                      clearable
                      dense
                      v-model="toAddS.pickupName"
                      required
                      :rules="rule1"
                    ></v-combobox>
                  </v-col>
                  <v-col cols="12" xs="12" sm="6" md="6" lg="6" style="margin-top: -20px">
                    <v-select
                      @change="GetDropPointDetail(toAddS.DropPoint)"
                      autocomplete="off"
                      style="font-family: Verdana"
                      :items="DropPointList"
                      v-model="toAddS.DropPoint"
                      clearable
                      dense
                      :label="$t('cars.dropPoint')"
                      required
                      :rules="[(v) => !!v || 'Drop Point is required']"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" xs="12" sm="6" md="6" lg="6" style="margin-top: -20px">
                    <v-select
                      @change="selectDropName(toAddS.DropPointDetails)"
                      autocomplete="off"
                      style="font-family: Verdana"
                      :items="DropDownDetailsList"
                      v-model="toAddS.DropPointDetails"
                      clearable
                      dense
                      :label="$t('cars.dropPoint')"
                      required
                      :rules="[(v) => !!v || 'Drop Point is required']"
                    ></v-select>
                  </v-col>
                  <v-col cols="6" xs="6" sm="6" md="6" lg="6" style="margin-top: -20px">
                    <v-select
                      @change="selectTime(toAddS.timeDisplay)"
                      style="font-family: Verdana"
                      :label="$t('cars.timeSchedule')"
                      :items="ScheduleTimeS"
                      clearable
                      dense
                      v-model="toAddS.timeDisplay"
                      required
                      :rules="rule2"
                    ></v-select>
                  </v-col>
                  <v-col cols="6" xs="6" sm="6" md="6" lg="6" style="margin-top: -30px">
                    <v-select
                      @change="cleartext()"
                      style="font-family: Verdana"
                      v-model="toAddS.TypeRequest"
                      :label="$t('cars.lbltype')"
                      :items="TypeRequest"
                      required
                      :rules="ruleType"
                    >
                    </v-select>
                  </v-col>

                  <v-col cols="6" xs="6" sm="6" md="6" lg="6" style="margin-top: -30px">
                    <v-select
                      :label="$t('cars.purpose')"
                      style="font-family: Verdana"
                      v-model="toAddS.Remarks"
                      required
                      :rules="rule3"
                      :items="
                        toAddS.TypeRequest == 'Business Use'
                          ? BusinessReason
                          : NotBusiness
                      "
                    >
                    </v-select>
                  </v-col>

                  <v-col
                    cols="6"
                    xs="6"
                    style="margin-top: -30px"
                    v-if="toAddS.TypeRequest == 'Business Use' ? true : false"
                  >
                    <v-select
                      :label="$t('cars.eventVenue')"
                      v-model="toAddS.EventVenue"
                      style="font-family: Verdana"
                      required
                      :rules="[(v) => !!v || 'Event Venue is required']"
                      :items="EventVenue"
                    >
                    </v-select>
                  </v-col>

                  <v-col
                    cols="6"
                    xs="6"
                    lg="12"
                    style="margin-top: -30px"
                    v-if="toAddS.Remarks == 'Others' ? true : false"
                  >
                    <v-text-field
                      label="Remarks"
                      v-model="toAddS.OtherRemarks"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <!-- <v-row wrap style="margin-top: -35px">
                      </v-row> -->

                <v-combobox
                  v-model="Members"
                  :items="employeeList"
                  filled
                  style="font-family: Verdana"
                  dense
                  chips
                  clearable
                  color="blue-grey lighten-2"
                  :label="$t('cars.memberlist')"
                  item-text="EmpName"
                  item-value="EmpName"
                  return-object
                  autocomplete="off"
                  multiple
                  required
                  :hint="
                    toAddS.TypeRequest == 'Not Business Use'
                      ? 'Need to add atleast 1 Member'
                      : 'Maximum of 5 Members'
                  "
                  persistent-hint
                  counter="5"
                >
                  <template v-slot:selection="data">
                    <v-chip
                      v-bind="data.attrs"
                      :input-value="data.selected"
                      color="yellow lighten-3"
                      close
                      style="font-family: Verdana"
                      @click="data.select"
                      @click:close="remove(data.item.empId)"
                    >
                      {{ data.item.EmpName }}
                    </v-chip>
                  </template>
                  <template v-slot:item="data">
                    <v-list-item-content style="font-family: Verdana">
                      <v-list-item-title v-text="data.item.EmpName"></v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-combobox>
              </v-form>
              <v-layout>
                <v-spacer></v-spacer>

                <v-btn
                  v-if="toAddS.TypeRequest === 'Not Business Use'"
                  @click="AddReserved()"
                  :disabled="!valid2 || Members.length === 0 ? true : false"
                  color="success"
                  style="font-family: Verdana"
                  >{{ btnName }}</v-btn
                >
                <v-btn
                  v-else
                  @click="AddReserved()"
                  :disabled="!valid2"
                  color="success"
                  style="font-family: Verdana"
                  >{{ btnName }}</v-btn
                >

                <v-spacer></v-spacer>
              </v-layout>
            </v-container>
          </v-card>
        </v-dialog>

        <v-dialog v-model="JoinDialog" persistent width="250">
          <v-card height="350">
            <v-toolbar dense color="yellow lighten-3">
              <v-toolbar-title>{{ $t("cars.details") }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn small icon @click="closeDialog()" class="mr-0"
                ><v-icon>mdi-close</v-icon></v-btn
              >
            </v-toolbar>
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-title
                  v-model="toAddS.timeDisplay"
                  class="headline mb-2 mt-0 text-center"
                  >{{ toAddS.timeDisplay }}</v-list-item-title
                >
                <v-list-item-subtitle>
                  <v-select
                    v-model="toAddS.pickupName"
                    :items="PickUpPointList"
                    dense
                    outlined
                    :label="$t('cars.pickupPoint')"
                    class="mt-2"
                    required
                  ></v-select>
                  <v-text-field
                    readonly
                    v-model="toAddS.DropPoint"
                    outlined
                    dense
                    :label="$t('cars.dropPoint')"
                    required
                  ></v-text-field>
                  <v-text-field
                    readonly
                    v-model="toAddS.DropPointDetails"
                    outlined
                    dense
                    :label="$t('cars.dropPoint')"
                    required
                  ></v-text-field>

                  <v-btn
                    @click="joinSpecialReservation()"
                    :disabled="!valid"
                    color="success"
                    block
                    dense
                    >Ok</v-btn
                  >
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-dialog>
      </v-container>
    </v-card>

    <v-snackbar v-model="snackbar" :timeout="3000" bottom right color="#298f41">
      <span style="font-family: Verdana"> Reservation canceled </span>
    </v-snackbar>
    <v-snackbar v-model="snackbar1" :timeout="3000" bottom right color="#298f41">
      <span v-if="btnName === 'Add Reservation'" style="font-family: Verdana">
        Reservation successfully added</span
      >
      <span v-else style="font-family: Verdana"> Reservation has been updated </span>
    </v-snackbar>

    <default-dialog
      :carsInfo="carsInfo"
      @closeDefaultDialog="closeDefaultDialog"
      :setDefaultDialog="setDefaultDialog"
    ></default-dialog>
  </div>
</template>

<script>
import moment from "moment-timezone";
// import axios from 'axios'
import _ from "lodash";
import BackToTop from "vue-backtotop";
import swal from "sweetalert";
import DefaultDialog from "@/components/DefaultDialog";
import api from "../api.js";
// import employeesList from "./sampleEmployee.json"
export default {
  components: {
    BackToTop,
    "default-dialog": DefaultDialog,
  },
  data() {
    return {
      specialTitle: "",
      btnName: "",
      closeActive: false,
      tabs: null,
      DialogR: false,
      DialogS: false,
      JoinDialog: false,
      ReserveData: [],
      PickUpPointList: [],
      toAdd: {},
      toAddS: {},
      dateToday: moment().format("YYYY-MM-DD"),
      daytoday: moment().format("dddd"),
      timeToday: "",
      carsReservationData: [],
      carsRegularReservation: [],
      carsSpecialReservation: [],
      carsSpecialReservation2: [],
      listIdreserved: [],
      EmpData: [],
      snackbar: false,
      snackbar1: false,
      snackbarUpdate: false,
      toLabel: {},
      ScheduleTimeS: [],
      employeeList: [],
      timeID: "",
      timeSpecialList: [],
      fName: {},
      empId: {},
      Members: [],
      MembersList: [],
      transferMembers: {},
      listofIDReserved: [],
      listofIDSpecialReserved: [],
      WithReserve: false,
      valid: true,
      valid2: true,
      rule1: [(v) => !!v || "Pickup Point is required"],
      rule2: [(v) => !!v || "Time Schedule is required"],
      rule3: [(v) => !!v || "Purpose is required"],
      ruleType: [(v) => !!v || "Type of request is required"],
      reservedData: [],
      carsDialog: false,
      btnTime: "",
      DropPointList: [],
      TypeRequest: ["Business Use", "Not Business Use"],

      BusinessUse: [
        "Local Fellowship",
        "Dinner with supplier",
        "Meeting with guest",
        "Overtime",
      ],
      NotBusiness: ["Dinner", "Sports", "Others"],
      EventVenue: ["Cavite", "Not Cavite"],
      ReservationLock: "",
      timeCutoff: ["", ""],
      timeData: [],
      setDefaultDialog: false,
      defaultSet: {},
      validDefault: true,
      carsInfo: {},
      overlay: true,
      FinishData: {},
      RegularwithPlateNo: [],
      RegularwithoutPlateNo: [],
      carsRegularReservationData: [],
      listIDneededtoEliminate: [],
      arry: ["Local Fellowship", "Dinner with supplier", "Meeting with guest"],
      vRemarks: {},
      notedRemarks: "",
      DropDownDetailsList: [],
    };
  },
  created() {
    // this.$EventBus.$on('SendCarUpdate',()=>{
    //     this.loadData()
    //     this.loadAllReservation()
    //     this.loadcutOff()
    //     this.checkDuplicate_async()
    //     this.loadRemarks()
    // })

    this.$socket.on("cars_update", () => {
      // console.log('line1591', data )
      // 2026-04-17
      this.loadData();
      this.loadAllReservation();
      this.loadcutOff();
      this.checkDuplicate_async();
      this.loadRemarks();
    });

    this.loadtimeData();
    this.loadFinishData();
    this.checkDuplicate_async();

    this.loadPickUp();
    this.loadData();
    this.loadDropPoint();
    this.loadAllReservation();
    this.loadUserdata();
    this.disableButton();
    this.loadcutOff();
    this.loadUserlist();
    this.loadRemarks();

    if (this.$i18n.locale == "en") {
      this.specialTitle = "Special Reservation";
    } else {
      this.specialTitle = "スペシャルカー予約";
    }
  },
  destroy() {},

  computed: {
    BusinessReason() {
      if (this.toAddS.timeDisplay < "19:30") {
        return this.arry;
      } else {
        return this.BusinessUse;
      }
    },
    ReserveData1() {
      return this.ReserveData.filter((rec) => {
        return !this.listIDneededtoEliminate.includes(rec.timeID);
      });
    },
    carsReservationData1() {
      return this.carsReservationData;
    },

    carsSpecialReservation1() {
      return this.carsSpecialReservation;
    },
    fontSize() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "3em";
        default:
          return "5em";
      }
    },
    adjustFontSize() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "0.5em";
        default:
          return "0.8125em";
      }
    },

    cutOff() {
      return moment().format(this.timeCutoff.toString());
    },
    reloadtime() {
      return moment().format("00:00:01");
    },

    buttonColor() {
      if (this.listIdreserved[0]) {
        if (this.listIdreserved[0].SpecialReq === false) {
          return "red lighten-3";
        } else {
          return "yellow lighten-3";
        }
      } else {
        return "white";
      }
    },
  },
  watch: {
    Members(val) {
      if (val.length > 5) {
        this.$nextTick(() => this.Members.pop());
      }
    },
  },
  mounted: function () {
    //running time
    setInterval(() => {
      this.timeToday = moment().tz("Asia/Manila").format("HH:mm:ss");
    }, 1000);
  },

  methods: {
    async onTooltipOpen( item ){  // 2026-06-17
      try{
        const url = `${this.api}getUsers/${item.empId}` 
        const response = await api.get(url)
        this.$set(item, 'internalLocalNumber', response.data.localNumber);
      }catch(err){
         console.log({ message: err.message })
         this.$set(item, 'internalLocalNumber', '-');
      }
    },
    loadRemarks() {
      let url = `${this.api}getRemarks`;
      api.get(url).then((res) => {
        if (res.data) {
          this.vRemarks.id = res.data[0].id;
          this.vRemarks.Eng = res.data[0].Eng;
          this.vRemarks.Jap = res.data[0].Jap;

          if (res.data[0].switch == false) {
            this.notedRemarks = "";
          } else {
            if (this.$i18n && this.$i18n.locale == "en") {
              this.notedRemarks = res.data[0].Eng;
            } else {
              this.notedRemarks = res.data[0].Jap;
            }
          }
        } else {
          this.vRemarks = {};
        }
      });
    },
    CheckDayCode(val) {
      if (val) {
        // console.log(val)
        if (moment().format("dddd") == val) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    loadAllReservation_Promise() {
      return new Promise((resolve) => {
        let url = `${this.api}reservation/${this.dateToday}`;

        api.get(url).then((res) => {
          this.carsRegularReservationData = _.chain(
            res.data.filter((rec) => {
              return rec.plateNo !== null;
            })
          )
            .groupBy("plateNo")
            .map((v) => ({
              plateNo: v[0].plateNo,
              capacity: v[0].capacity,
              count: v.length,
              timeId: v[0].timeID,
              recs: v,
            }))
            .value();

          // this.carsRegularReservationData[1] = _.chain(res.data.filter(rec =>{
          //   return rec.plateNo == null
          // }))
          //  .groupBy('timeID').map(v=>({
          //   plateNo : v[0].plateNo,
          //   capacity : v[0].capacity,
          //   count : v.length,
          //   timeId : v[0].timeID,
          //   recs : v
          // })).value()

          resolve(this.carsRegularReservationData);
        });
      });
    },

    loadFinishData_Promise() {
      return new Promise((resolve) => {
        let url = `${this.api}getDropPoint`;
        api.get(url).then((res) => {
          let fData = res.data.filter((r) => {
            return r.pointID == "000001DONE";
          });
          this.FinishData = fData[0];
          resolve(this.FinishData);
        });
      });
    },

    gatherDatawithPlateNo_Promise(Regular) {
      return new Promise((resolve) => {
        if (Regular.length !== 0) {
          let rData = Regular.filter((rec) => {
            return rec.count !== rec.capacity - 1;
          }).map((r1) => {
            return r1.timeId;
          });
          this.RegularwithPlateNo = rData;
          resolve(this.RegularwithPlateNo);
        }
      });
    },
    gatherDatawithoutPlateNo_Promise(Regular) {
      return new Promise((resolve) => {
        if (Regular.length !== 0) {
          let rData = Regular[0].recs.filter((rec) => {
            return rec.PlateNo == "null";
          });
          this.RegularwithoutPlateNo = rData.map((r1) => {
            return r1.timeID;
          });
        }
        resolve(this.RegularwithoutPlateNo);
      });
    },

    async checkDuplicate_async() {
      const DataFinish = await this.loadFinishData_Promise();
      if (DataFinish.SelectUse == "True") {
        // <---- for select only time needed to delete ---->
        // const rgData = await this.loadAllReservation_Promise();
        // const withPlateNo = await this.gatherDatawithPlateNo_Promise(rgData);
        //  this.listIDneededtoEliminate = withPlateNo
        // .filter(rec =>{
        //   return !withoutPlateNo.includes(rec)
        // })
        // console.log(this.listIDneededtoEliminate)

        // const withoutPlateNo = await this.gatherDatawithoutPlateNo_Promise(rgData);
        //  <---- for select only time needed to delete ---->

        this.listIDneededtoEliminate = this.ReserveData.map((rec) => {
          return rec.timeID;
        });
      } else {
        this.listIDneededtoEliminate = [];
      }
    },

    loadFinishData() {
      let url = `${this.api}getDropPoint`;
      api.get(url).then((res) => {
        let fData = res.data.filter((r) => {
          return r.pointID == "000001DONE";
        });
        if (fData[0].PointName !== this.dateToday) {
          let dataF = {
            pointID: "000001DONE",
            PointName: this.dateToday,
            SelectUse: "False",
          };
          let url = `${this.api}updateDropOff`;
          api.put(url, dataF).then(() => {
            this.FinishData = dataF;
            // console.log(res.data)
            this.checkDuplicate();
          });
        } else {
          this.FinishData = fData[0];
          this.checkDuplicate();
        }
      });
    },

    checkDuplicate() {
      //ReserveData == list of timeData
      //carsRegularReservation
      // console.log(this.carsRegularReservation)
      if (this.carsRegularReservation.length !== 0) {
        let CarsCapacity = this.carsRegularReservation[0].recs.filter((rec) => {
          return rec.PlateNo !== "null" && rec.Capacity - 1 !== rec.recs1.length;
        });
        // console.log('CarsCapacity',CarsCapacity)
        let CarsNoPlate = this.carsRegularReservation[0].recs.filter((rec) => {
          return rec.PlateNo == "null";
        });
        // console.log('CarsNoPlate',CarsNoPlate)

        this.RegularwithPlateNo = CarsCapacity.map((recs) => {
          return { timeID: recs.timeID };
        });
        this.RegularwithoutPlateNo = CarsNoPlate.map((rc) => {
          return { timeID: rc.timeID };
        });
      }
    },
    async OpenDefaultDialog() {
      // 2026-04-22
      try {
        if (!this.EmpData.PickUpPoint) {
          this.setDefaultDialog = true;
          console.log("UNDEFINED-CALL GUEST CARS USER");
          const response = await api.get(`${this.api}auth/getGuestCARSUser`);
          const user = response.data;
          this.setDefaultDialog = true;
          this.carsInfo = user;
          return;
        }

        this.setDefaultDialog = true;
        this.defaultSet = this.EmpData;
      } catch (err) {
        console.log("line1036", err.message);
      }
    },
    // OpenDefaultDialog(){  // OLD
    //   this.setDefaultDialog = true
    //   this.defaultSet = this.EmpData
    // },
    closeDefaultDialog() {
      this.setDefaultDialog = false;
    },
    selectDropName(val) {
      this.toAddS.DropName = val;
    },
    loadcutOff() { // tanskie 2026-05-13
      let url = `${this.api}cartypelist`;
      api.get(url).then((res) => {
        this.timeData = res.data.filter((r) => {
          return r.id === "000001";
        });

        // console.log('line1897', this.timeData )
        // console.log(this.timeData[0].cartype)
          this.ReservationLock = this.timeData[0].cartype;

          let data1 = this.timeData[0].capacity;
          //  console.log(this.employeedata)
          this.timeCutoff[0] = data1.substr(0, 2);
          this.timeCutoff[1] = data1.substr(3, 2);
      });
    },
    loadtimeData() {
      let url = `${this.api}getTimesched`;
      api.get(url).then((res) => {
        this.ReserveData = _.orderBy(res.data, ["timeDisplay"], ["ASC"]).filter((rec) => {
          return rec.useSpecial == false && rec.useView == true;
        });

        // if(this.daytoday !== 'Friday'){

        // }else{
        //   this.ReserveData =_.orderBy(res.data, ['timeDisplay'], ['ASC']).filter(rec =>{
        //   return rec.useSpecial == false && (rec.timeSched === '16:45' || rec.timeSched ==='17:45' || rec.timeSched ==='18:00')
        //  })
        // }

        this.ScheduleTimeS = _.orderBy(res.data, ["timeDisplay"], ["ASC"])
          .filter((rec) => {
            return rec.useSpecial == true && rec.useView == true;
          })
          .map((r) => {
            return r.timeDisplay;
          });
        // if(this.daytoday !== 'Friday'){

        // }
        // else{
        //   this.ScheduleTimeS = _.orderBy(res.data, ['timeDisplay'], ['ASC']).filter(rec =>{
        //     return rec.useSpecial == true  && (rec.timeSched < '18:00' || rec.timeSched > '19:30')
        //   }).map(r => {
        //     return r.timeDisplay
        //   })
        // }
        this.timeSpecialList = res.data.filter((rec) => {
          return rec.useSpecial == true && rec.useView == true;
        });

        this.currentTime = this.currentTime;
      });
    },

    openDialogS() {
      if (this.$i18n.locale == "en") {
        this.specialTitle = "Special Reservation";
        this.btnName = "Add Reservation";
      } else {
        this.specialTitle = "スペシャルカー予約";
        this.btnName = "加算 スペシャルカー予約";
      }
      let url = `${this.api}getUsers/${this.userData.id}`;
      api
        .get(url)
        .then((res) => {
          this.EmpData = res.data;
          this.carsInfo = res.data;
          this.DialogS = true;
          this.toAddS.R_Name =
            this.EmpData.LastNameEng + ", " + this.EmpData.FirstNameEng;
          this.toAddS.R_id = this.EmpData.id;
          this.toAddS.pickupName = this.EmpData.PickUpPoint;
          this.toAddS.localNumber = this.EmpData.phoneNumber;
          this.toAddS.DropPoint = this.EmpData.DropPoint;
          this.GetDropPointDetail(this.EmpData.DropPoint);
          this.toAddS.DropPointDetails = this.EmpData.DropPointDetails;

          this.loadUserlist();
          if (!res.data) {
            let url2 = `${this.api}guest_user/${this.userData.id}`;
            api
              .get(url2)
              .then((res2) => {
                if (res2.data) {
                  this.EmpData = res2.data;
                  this.carsInfo = res2.data;
                }
              })
              .catch((err2) => {
                console.log(err2.message);
              });
          }
        })
        .catch((err) => {
          console.log(err.message);
          // Check if User does not existing in Soumu System ( 2022-01-31 )
          let url2 = `${this.api}guest_user/${this.userData.id}`;
          api
            .get(url2)
            .then((res2) => {
              if (res2.data) {
                this.EmpData = res2.data;
                this.carsInfo = res2.data;
              }
            })
            .catch((err2) => {
              console.log(err2.message);
            });
        });
    },

    closeDialogS() {
      this.DialogS = false;
      this.carsDialog = false;
      this.toAddS = {};
      this.toLabel = {};
      this.Members = [];
      this.MembersList = [];
      this.reset();
    },
    reset() {
      this.$refs.form.reset();
    },
    cleartext() {
      this.toAddS.Remarks = null;
      this.toAddS.EventVenue = null;
    },

    closeDialog() {
      this.DialogR = false;
      this.toAdd = {};
      this.JoinDialog = false;
      this.toAddS = {};
    },
    openCarsDialog() {
      // console.log(val)
      this.carsDialog = true;
    },
    EnableJoin(rec) {
      // console.log(rec)
      let url = `${this.api}getUsers/${this.userData.id}`;
      api
        .get(url)
        .then((res) => {
          this.EmpData = res.data;
          this.carsInfo = res.data;

          this.toAdd.timeDisplay = rec.timeDisplay;
          this.toAdd.timeID = rec.timeID;
          this.toAdd.pickupName = this.EmpData.PickUpPoint;
          this.toAdd.DropPoint = this.EmpData.DropPoint;
          this.toAdd.DropPointDetails = this.EmpData.DropPointDetails;
          this.toAdd.empId = this.userData.id;
          this.toAdd.DateScheduled = this.dateToday;
          this.toAdd.EmpName =
            this.userData.LastNameEng + ", " + this.userData.FirstNameEng;
          this.toAdd.R_id = this.userData.id;
          this.toAdd.R_Name =
            this.userData.LastNameEng + ", " + this.userData.FirstNameEng;
          this.toAdd.localNumber = this.userData.phoneNumber;

          this.toAdd.designation = rec.designation;
          this.toAdd.SpecialReq = false;
          this.toAdd.plateNo = rec.plateNo;
          this.toAdd.Driver = rec.Driver;
          this.toAdd.license_no = rec.license_no;
          this.toAdd.typeofCar = rec.typeofCar;
          this.toAdd.driverContacts = rec.driverContacts;
          this.toAdd.capacity = rec.capacity;
          this.toAdd.Remarks = null;
          this.toAdd.Day_Code = rec.Day_Code; //12-14-21
          this.DialogR = true;

          if (!res.data) {
            let url2 = `${this.api}guest_user/${this.userData.id}`;
            api
              .get(url2)
              .then((res2) => {
                if (res2.data) {
                  this.EmpData = res2.data;
                  this.carsInfo = res2.data;
                }
              })
              .catch((err2) => {
                console.log(err2.message);
              });
          }
        })
        .catch((err) => {
          console.log(err.message);
          // Check if User does not existing in Soumu System ( 2022-01-31 )
          let url2 = `${this.api}guest_user/${this.userData.id}`;
          api
            .get(url2)
            .then((res2) => {
              if (res2.data) {
                this.EmpData = res2.data;
                this.carsInfo = res2.data;
              }
            })
            .catch((err2) => {
              console.log(err2.message);
            });
        });
    },

    async selectName(rec) {
      // 2026-04-22
      try {
        // 1. Fetch the user data cleanly
        let res = await api.get(`${this.api}getUsers/${this.userData.id}`);
        let activeData = res.data;

        // 2. LOGICAL FIX: Check for the 404 status FIRST
        if (activeData.status == 404) {
          // If 404, fetch the guest user and OVERWRITE activeData
          const res2 = await api.get(`${this.api}auth/getGuestCARSUser`);
          activeData = res2.data;
          activeData.phoneNumber = res2.data.cellphoneNumber
            ? res2.data.cellphoneNumber
            : "-";
          activeData.localNumber = res2.data.cellphoneNumber
            ? res2.data.cellphoneNumber
            : "-";
        }

        // 3.  the correct data (User OR Guest)
        this.EmpData = activeData;
        this.carsInfo = activeData;

        const fullName = `${this.userData.LastNameEng}, ${this.userData.FirstNameEng}`;

        // This prevents crashes if PickUpPoint happens to be missing.
        this.toAdd.timeDisplay = rec.timeDisplay;
        this.toAdd.timeID = rec.timeID;
        this.toAdd.pickupName = activeData.PickUpPoint || "";
        this.toAdd.DropPoint = activeData.DropPoint || "";
        this.toAdd.DropPointDetails = activeData.DropPointDetails || "";

        // User Data mappings
        this.toAdd.empId = this.userData.id;
        this.toAdd.DateScheduled = this.dateToday;
        this.toAdd.EmpName = fullName;
        this.toAdd.R_id = this.userData.id;
        this.toAdd.R_Name = fullName;
        this.toAdd.localNumber =
          this.userData.UserLevel == "Guest"
            ? this.userData.cellphoneNumber
            : this.userData.phoneNumber; // 2026-04-22
        this.toAdd.phoneNumber =
          this.userData.UserLevel == "Guest"
            ? this.userData.cellphoneNumber
            : this.userData.phoneNumber; // 2026-04-22

        // Default Resets
        this.toAdd.designation = 0;
        this.toAdd.SpecialReq = false;
        this.toAdd.plateNo = null;
        this.toAdd.Driver = null;
        this.toAdd.license_no = null;
        this.toAdd.typeofCar = null;
        this.toAdd.driverContacts = null;
        this.toAdd.Remarks = null;
        this.toAdd.Day_Code = null; // 12-14-21

        // 5. Finally, open the dialog ONLY AFTER all data is perfectly loaded
        this.DialogR = true;
      } catch (err) {
        // 6. Clean error catching
        console.error("Error in selectName:", err.message || err);
        alert("Failed to load user information.");
      }
    },
    // async selectName(rec){  // old

    //   let url = `${this.api}getUsers/${this.userData.id}`
    //   api.get(url).then (async res => {

    //     this.EmpData = res.data
    //     this.carsInfo = res.data
    //     this.toAdd.timeDisplay = rec.timeDisplay
    //     this.toAdd.timeID = rec.timeID
    //     this.toAdd.pickupName = this.EmpData.PickUpPoint
    //     this.toAdd.DropPoint = this.EmpData.DropPoint
    //     this.toAdd.DropPointDetails = this.EmpData.DropPointDetails
    //     this.toAdd.empId = this.userData.id
    //     this.toAdd.DateScheduled = this.dateToday
    //     this.toAdd.EmpName = this.userData.LastNameEng  +', '+ this.userData.FirstNameEng
    //     this.toAdd.R_id = this.userData.id
    //     this.toAdd.R_Name = this.userData.LastNameEng  +', '+ this.userData.FirstNameEng
    //     this.toAdd.localNumber = this.userData.phoneNumber
    //     this.toAdd.phoneNumber = this.userData.phoneNumber
    //     this.toAdd.designation = 0
    //     this.toAdd.SpecialReq = false
    //     this.toAdd.plateNo = null
    //     this.toAdd.Driver = null
    //     this.toAdd.license_no = null
    //     this.toAdd.typeofCar = null
    //     this.toAdd.driverContacts = null
    //     this.toAdd.Remarks = null
    //     this.toAdd.Day_Code = null //12-14-21

    //     this.DialogR = true

    //     // if( res.data.status == '404') {}

    //     if(res.data.status == 404 ){
    //          const res2 = await api.get(`${this.api}auth/getGuestCARSUser`);
    //          this.EmpData = res2.data;
    //          this.carsInfo = res2.data
    //     }
    //   }).catch(err=>{
    //      console.log({ message: err.message })
    //   })

    // },

    async selectNameS(rec) {

      if (this.EmpData.status == 404) {  // 2026-04-22
        // Guest User
        const response = await api.get(`${this.api}auth/getGuestCARSUser`);
        const user = response.data;
        this.toAddS = user;
        this.toAddS.pickupName = user.PickUpPoint;
        this.toAddS.localNumber = user.cellphoneNumber ? user.cellphoneNumber : "-";
  
        this.JoinDialog = true;
        return;
      }

      this.toAddS.timeDisplay = rec[0].timeDisplay;
      this.toAddS.timeID = rec[0].timeID;
      this.toAddS.pickupName = this.EmpData.PickUpPoint;
      this.toAdd.DropPointDetails = this.EmpData.DropPointDetails;
      this.toAddS.DropPoint = this.EmpData.DropPoint;
      this.toAddS.empId = this.userData.id;
      this.toAddS.DateScheduled = this.dateToday;
      this.toAddS.EmpName = this.userData.LastNameEng + ", " + this.userData.FirstNameEng;
      this.toAddS.R_id = rec[0].R_id;
      this.toAddS.R_Name = rec[0].R_Name;
      this.toAddS.designation = 0;
      this.toAddS.SpecialReq = true;
      this.toAddS.plateNo = null;
      this.toAddS.Driver = null;
      this.toAddS.license_no = null;
      this.toAddS.typeofCar = null;
      this.toAddS.Day_Code = null; //12-14-21
      this.toAddS.driverContacts = null;
      this.toAddS.Remarks = rec[0].Remarks;
      this.JoinDialog = true;
      this.toAddS.localNumber = rec[0].localNumber;
      this.toAdd.phoneNumber = rec[0].phoneNumber;

      this.GetDropPointDetail(rec[0].DropPoint);
      this.toAddS.DropPointDetails = this.EmpData.DropPointDetails;
    },

    canceReservation(rec, empId) {
      let msgDelete = "";
      let msgYes = "";
      let msgNo = "";

      if (this.$i18n.locale === "en") {
        msgDelete = "Do you want to cancel your reservation?";
        msgYes = "YES";
        msgNo = "NO";
      } else {
        msgDelete = "予約をキャンセルしますか？";
        msgYes = "はい ";
        msgNo = "いいえ";
      }
      swal({
        title: msgDelete,
        icon: "warning",
        closeOnEsc: false,
        closeOnClickOutside: false,
        buttons: [msgYes, msgNo],
      }).then((willApprove) => {
        if (!willApprove) {
          const index = this.carsReservationData.indexOf(rec);
          this.carsReservationData.splice(index, 1);
          let url = `${this.api}deleteReservation`;
          api.post(url, { empId: empId }).then(() => {
            // console.log(res.data)

            this.$socket.emit("cars_update", empId);
            this.snackbar = true;
            // setTimeout(() => {
            //   location.reload()
            // }, 500);
            // this.loadData()
            // this.loadReservation()
            // this.loadAllReservation()
          });
        }
      });
    },

    cancelReservation(empId, EmpName) {
      let msgDelete = "";
      let msgYes = "";
      let msgNo = "";

      if (this.userData.id === empId) {
        msgDelete = "Do you want to cancel your reservation?";
      } else {
        msgDelete = "Do you want to cancel " + EmpName + " reservation?";
      }

      msgYes = "YES";
      msgNo = "NO";
      if (this.$i18n.locale === "en") {
        if (this.userData.id === empId) {
          msgDelete = "Do you want to cancel your reservation?";
        } else {
          msgDelete = "Do you want to cancel " + EmpName + " reservation?";
        }

        msgYes = "YES";
        msgNo = "NO";
      } else {
        if (this.userData.id === empId) {
          msgDelete = "予約をキャンセルしますか？";
        } else {
          msgDelete = EmpName + " 予約をキャンセルしますか?";
        }
        msgYes = "はい ";
        msgNo = "いいえ";
      }
      swal({
        title: msgDelete,
        icon: "warning",
        closeOnEsc: false,
        closeOnClickOutside: false,
        buttons: [msgYes, msgNo],
      }).then((willApprove) => {
        if (!willApprove) {
          let url = `${this.api}deleteReservation`;
          api.post(url, { empId: empId }).then(() => {
            this.$socket.emit("cars_update", empId);
            this.snackbar = true;
          });
        }
      });
    },
    cancelAllspecialReserve() {
      let msgDelete = "";
      let msgYes = "";
      let msgNo = "";
      if (this.$i18n.locale === "en") {
        msgDelete = "Do you want to cancel the reservation?";
        msgYes = "YES";
        msgNo = "NO";
      } else {
        msgDelete = "予約をキャンセルしますか？";
        msgYes = "はい ";
        msgNo = "いいえ";
      }
      swal({
        title: msgDelete,
        icon: "warning",
        closeOnEsc: false,
        closeOnClickOutside: false,
        buttons: [msgYes, msgNo],
      }).then((willApprove) => {
        if (!willApprove) {
          for (let a = 0; a < this.listofIDSpecialReserved.length; a++) {
            let url = `${this.api}deleteReservation`;
            api.post(url, { empId: this.listofIDSpecialReserved[a].empId }).then(() => {
              this.$socket.emit("cars_update", this.listofIDSpecialReserved[a].empId);
            });
          }
          // this.loadReservation()
          //     this.loadData()
          this.snackbar = true;
        }
      });
    },

    editSpcialReserv(rec) {
      if (this.$i18n.locale == "en") {
        this.specialTitle = "Edit Special Reservation";
        this.btnName = "Update Reservation";
      } else {
        this.specialTitle = "エディット スペシャルカー予約";
        this.btnName = "更新 スペシャルカー予約";
      }

      // console.log(rec)
      //  this.loadData()
      this.loadUserlist();
      this.DialogS = true;
      for (let i = 0; i < rec.length; i++) {
        if (rec[i].empId === this.userData.id) {
          this.toAddS.timeDisplay = rec[i].timeDisplay;
          this.toAddS.timeID = rec[i].timeID;
          this.toAddS.pickupName = rec[i].pickupName;
          this.toAddS.DropPoint = rec[i].DropPoint;

          this.toAddS.empId = rec[i].empId;
          this.toAddS.DateScheduled = this.dateToday;
          this.toAddS.EmpName = rec[i].EmpName;
          this.toAddS.R_id = rec[i].R_id;
          this.toAddS.R_Name = rec[i].R_Name;
          this.toAddS.designation = 0;
          this.toAddS.SpecialReq = true;
          this.toAddS.plateNo = null;
          this.toAddS.license_no = null;
          this.toAddS.Remarks = rec[i].Remarks;
          this.toAddS.localNumber = rec[i].localNumber;
          this.toAddS.TypeRequest = rec[i].TypeRequest;
          this.toAddS.EventVenue = rec[i].EventVenue;
          this.toAddS.OtherRemarks = rec[i].OtherRemarks;

          // setTimeout(() => {
          this.GetDropPointDetail(rec[i].DropPoint);
          this.toAddS.DropPointDetails = rec[i].DropPointDetails;
          // }, 1200);
        } else {
          let str = rec[i].EmpName;
          let sStr = str.split(" ");
          let sur = sStr[sStr.length - 1];
          let fir = sStr[sStr.length - 2];
          let surfir = sur + ", " + fir;

          this.Members.push({
            name: surfir,
            EmpName: rec[i].EmpName,
            empId: rec[i].empId,
            PickUpPoint: rec[i].pickupName,
          });
        }
      }
    },

    loadPickUp() {
      let url = `${this.api}getPickPoint`;
      api.get(url).then((res) => {
        this.PickUpPointList = res.data
          .filter((rec) => {
            return rec.SelectUse == "Yes";
          })
          .map((rec1) => {
            return rec1.PointName;
          })
          .sort();
      });
    },

    loadDropPoint() {
      let url = `${this.api}getDropPoint`;
      api.get(url).then((res) => {
        this.DropPointList = res.data
          .filter((rec) => {
            return rec.SelectUse == "Yes" && rec.PointNameArea != undefined;
          })
          .map((rec1) => {
            return rec1.PointNameArea;
          })
          .sort();
      });
    },
    GetDropPointDetail(drop_area) {
      this.DropDownDetailsList = [];
      let tmpOthers = "OTHER";
      if (drop_area) {
        this.DropDownDetailsList = this.$store.state.dropPointArrList
          .filter((rec) => {
            return rec.PointNameArea == drop_area && rec.PointName != "OTHER";
          })
          .map((rec1) => {
            return rec1.PointName;
          })
          .sort((a, b) => {
            return a > b ? 1 : -1;
          });

        this.DropDownDetailsList.push(tmpOthers);
      }
    },

    joinReservation() {
      // 2026-04-22
      console.log("join reservation - Regular");
      const url = `${this.api}AddSched`;
      api.post(url, this.toAdd).then(() => {

        this.$socket.emit("cars_update", this.toAdd);
        
        // this.$socket.emit("cars_update", employeesList);

        let msgTitle = "Successfully Reserved";
        swal(msgTitle, " ", "success", {
          timer: 2000,
          button: false,
        });
        this.$socket.emit("show_notification", this.toAdd);
        this.disableButton();
        this.closeDialog();
      });
    },
    joinSpecialReservation() {
      let msgTitle = "Successfully Reserved";
      swal(msgTitle, " ", "success", {
        timer: 1000,
        button: false,
      });

      let url = `${this.api}AddSched`;
      api.post(url, this.toAddS).then(() => {
        this.$socket.emit("cars_update", this.toAddS);
        // this.loadAllReservation()
        // this.loadData()
        this.disableButton();
        this.closeDialog();
        //  this.loadReservation()
        this.loadtimeData();
      });
    },

    loadReservation() {
      let url = `${this.api}reservation/${this.dateToday}`;

      api.get(url).then((res) => {
        this.carsReservationData = res.data.filter((rec) => {
          return rec.SpecialReq == false;
        });

        this.overlay = false;
      });
    },
    promiseGetEmployeeInfo(employeeId) {
      return new Promise((resolve, reject) => {
        const url = `${this.api}getUsers/${employeeId}`;
        api
          .get(url)
          .then((res) => {
            if (res.data) {
              resolve(res.data);
            }
          })
          .catch((err) => {
            reject({ message: err.message });
          });
      });
    },


    promiseGetGuestUser( employeeId ) {  // 2026-04-22
      return new Promise((resolve, reject) => {
        const url = `${this.api}guest_user/${employeeId}`;
        api
          .get(url)
          .then((res) => {
            if (res.data) {
              resolve(res.data);
            }
          })
          .catch((err) => {
            reject({ message: err.message });
          });
      });
    },
    loadAllReservation() {
      let url = `${this.api}AllReservation/${this.dateToday}`;
      api.get(url).then(async (res) => {
        //  console.log('line2566', res.data )
        //  this.carsSpecialReservation = res.data.filter(rec =>{
        //    return rec.SpecialReq == true
        //  })

        //  this.carsRegularReservation = res.data.filter(rec1 =>{
        //    return rec1.SpecialReq == false
        //  })

        // OLD
        // this.carsRegularReservation = res.data[0]
        // this.carsSpecialReservation = res.data[1]

        this.carsRegularReservation = res.data[0];
        this.carsSpecialReservation = res.data[1];

        let tmpCarsSpecial = res.data[1].map(async (rec) => {
          // 2022-11-08
          let resevationList = rec.recs[0].recs1;
          // console.log('line1511',resevationList)
          resevationList.map(async (item) => {
            let objData = await this.promiseGetEmployeeInfo(item.empId);
            let objGuestUserData = await this.promiseGetGuestUser(item.empId )
    
            item.DropPoint = objData.status == 404 ? objGuestUserData.DropPoint: objData.DropPoint;  // 2026-04-22 if 404 Guest User else Japanese User
            item.DropPointDetails = objData.status == 404 ? objGuestUserData.DropPointDetails : objData.DropPointDetails; // 2026-04-22 if 404 Guest User else Japanese User
            item.localNumber = objData.status == 404 ? objGuestUserData.cellphoneNumber :  objData.phoneNumber != undefined ? objData.phoneNumber : "---"; // 2026-04-22 if 404 Guest User else Japanese User
            return item;
          });
          return rec;
        });
        this.carsSpecialReservation = await Promise.all(tmpCarsSpecial);
      });
    },
    loadData() {
      let url = `${this.api}reservation/${this.dateToday}`;
      api.get(url).then((res) => {
        this.listIdreserved = res.data.filter((rec) => {
          return rec.empId == this.userData.id;
        });

        this.listofIDReserved = res.data.map((rec1) => {
          return rec1.empId;
        });

        this.listofIDSpecialReserved = res.data.filter((r) => {
          return r.R_id == this.userData.id;
        });

        this.carsReservationData = res.data.filter((rec) => {
          return rec.SpecialReq == false;
        });

        this.overlay = false;
      });
    },
    selectTab() {
      this.listIdreserved.map((rec) => {
        // console.log(rec.SpecialReq)
        if (rec.SpecialReq === true) {
          this.tabs = 1;
        } else {
          this.tabs = 0;
        }
      });
    },

    loadUserdata() {
      let url = `${this.api}getUsers/${this.userData.id}`;
      api
        .get(url)
        .then((res) => {
          this.EmpData = res.data;
          this.carsInfo = res.data;
          if (!res.data) {
            let url2 = `${this.api}guest_user/${this.userData.id}`;
            api
              .get(url2)
              .then((res2) => {
                if (res2.data) {
                  this.EmpData = res2.data;
                  this.carsInfo = res2.data;
                }
              })
              .catch((err2) => {
                console.log(err2.message);
              });
          }
        })
        .catch((err) => {
          console.log(err.message);
          // Check if User does not existing in Soumu System ( 2022-01-31 )
          let url2 = `${this.api}guest_user/${this.userData.id}`;
          api
            .get(url2)
            .then((res2) => {
              if (res2.data) {
                this.EmpData = res2.data;
                this.carsInfo = res2.data;
              }
            })
            .catch((err2) => {
              console.log(err2.message);
            });
        });
    },

    loadUserlist() {
      let url = `${this.api}getUserswithCars`;
      api.get(url).then((res) => {
        if (
          this.specialTitle === "Special Reservation" ||
          this.specialTitle === "スペシャルカー予約"
        ) {
          this.employeeList = _.orderBy(res.data, ["LastNameEng"], ["ASC"])
            .filter((r) => {
              return (
                !this.listofIDReserved.includes(r.id) &&
                r.id !== this.userData.id &&
                r.id !== "00000" &&
                r.Status == "Active"
              );
            })
            .map((rec) => {
              return {
                EmpName: rec.LastNameEng + ", " + rec.FirstNameEng,
                empId: rec.id,
                PickUpPoint: rec.PickUpPoint,
                localNumber: rec.localNumber,
              };
            });
        } else if (
          this.specialTitle === "Edit Special Reservation" ||
          this.specialTitle === "エディット スペシャルカー予約"
        ) {
          this.employeeList = _.orderBy(res.data, ["LastNameEng"], ["ASC"])
            .filter((r) => {
              return (
                r.id !== this.userData.id && r.id !== "00000" && r.Status == "Active"
              );
            })
            .map((rec) => {
              return {
                EmpName: rec.LastNameEng + ", " + rec.FirstNameEng,
                empId: rec.id,
                PickUpPoint: rec.PickUpPoint,
                localNumber: rec.localNumber,
              };
            });
        }
      });
    },
    selectPickUpName(val) {
      this.toAddS.pickupName = val;
    },

    remove(item) {
      var index = this.Members.map((e) => {
        return e.empId;
      }).indexOf(item);
      if (index >= 0) this.Members.splice(index, 1);
      if (this.specialTitle === "Yes") {
        let url = `${this.api}deleteReservation`;
        api.post(url, { empId: item }).then(() => {});
      }
    },
    selectTime(val) {
      //  this.toAdd.ScheduleTime = val
      this.toAddS.timeDisplay = val;
      this.timeID = this.timeSpecialList
        .filter((rec) => {
          return rec.timeDisplay === val;
        })
        .map((r) => {
          return r.timeID;
        });
      this.toAddS.timeID = this.timeID.toString();

      //  console.log(this.ScheduleTime)
      //  this.toAdd.timeID = this.timeID
    },

    AddReserved() {
      this.transferMembers.EmpName = this.toAddS.R_Name;
      this.transferMembers.empId = this.toAddS.R_id;
      this.transferMembers.PickUpPoint = this.toAddS.pickupName;
      this.transferMembers.localNumber = this.toAddS.localNumber;
      this.MembersList.push(this.transferMembers);

      for (let a = 0; a < this.Members.length; a++) {
        this.MembersList.push(this.Members[a]);
      }

      for (let i = 0; i < this.MembersList.length; i++) {
        setTimeout(() => {
          this.toAddS.EmpName = this.MembersList[i].EmpName;
          this.toAddS.empId = this.MembersList[i].empId;
          this.toAddS.pickupName = this.MembersList[i].PickUpPoint;
          this.toAddS.PickUpPointDetails = this.MembersList[i].PickUpPointDetails;
          this.toAddS.localNumber = this.MembersList[i].localNumber;
          this.toAddS.DateScheduled = this.dateToday;
          this.toAddS.SpecialReq = true;
          this.toAddS.plateNo = null;
          this.toAddS.typeofCar = null;
          this.toAddS.driverContacts = null;
          this.toAddS.Driver = null;
          this.toAddS.license_no = null;
          this.toAddS.designation = 0;
          this.toAddS.Day_Code = null;

          // console.log('here',this.toAddS)
          let url = `${this.api}AddSched`;
          api.post(url, this.toAddS).then(() => {
            // console.log (res.data)
            let msgTitle = "Successfully Reserved";
            swal(msgTitle, " ", "success", {
              timer: 1000,
              button: false,
            });
            this.$socket.emit("cars_update", this.toAddS);
            this.closeDialogS();
            //  location.reload()
            this.tabs = 1;
            this.snackbar1 = true;
          });
        }, 1000);
      }

      //  if(this.daytoday !== 'Friday'){
      //  }else{
      //    if(this.MembersList.length < 4){
      //       alert('Need 4 person and above for Special Reservation')
      //     this.MembersList = []
      //    }else{
      //      for (let i = 0; i < this.MembersList.length; i++){
      //        setTimeout(() =>{
      //        this.toAddS.EmpName = this.MembersList[i].EmpName
      //       this.toAddS.empId = this.MembersList[i].empId
      //       this.toAddS.pickupName = this.MembersList[i].PickUpPoint
      //       this.toAddS.localNumber = this.MembersList[i].localNumber
      //       this.toAddS.DateScheduled = this.dateToday
      //       this.toAddS.SpecialReq = true
      //       this.toAddS.plateNo = null
      //       this.toAddS.typeofCar = null
      //       this.toAddS.driverContacts = null
      //       this.toAddS.Driver = null
      //       this.toAddS.license_no = null
      //       this.toAddS.designation = 0

      //      let url = `${this.api}AddSched`
      //          api.post(url, this.toAddS).then (res => {
      //         console.log (res.data)
      //          this.closeDialogS()
      //           let msgTitle = "Successfully Reserved"
      //         swal( msgTitle, " " , "success" , {
      //         timer: 1000,
      //         button:false
      //          })
      //         //  location.reload()
      //           this.tabs = 1
      //             this.snackbar1 = true
      //           })

      //      }, 500)

      //    }

      //    }

      //  }
    },

    disableButton() {
      if (this.listIdreserved.length == 0) {
        this.WithReserve = false;
      } else {
        this.WithReserve = true;
      }
    },
  },
};
</script>

<style>
.swal-button--cancel {
  background: #57c0f7 !important;
  color: white !important;
}
.swal-button--confirm {
  background: #dedad9 !important;
  color: #4d4e4f !important;
}

table,
th,
td {
  border: 1px solid grey !important;
}
td {
  padding: 3px !important;
}

th {
  background-color: #213c57 !important;
  color: white !important;
  font-family: Arial !important;
  padding: 15px !important;
  font-size: 13px;
}
tr:hover {
  background-color: #cdcdd1 !important;
}
</style>
